import './Footer.scss';

const Footer = () => {

    return (
        <div className="Footer">
            
        </div>
    );
}

export default Footer;